import script from "./page-1-b2.vue?vue&type=script&setup=true&lang=js"
export * from "./page-1-b2.vue?vue&type=script&setup=true&lang=js"

import "./page-1-b2.vue?vue&type=style&index=0&id=075c52eb&lang=css"

const __exports__ = script;

export default __exports__